// extracted by mini-css-extract-plugin
export default {"loaderWraper":"Loader_loaderWraper__I+XCl","ldsRipple":"Loader_ldsRipple__dJSar"};